export const useExchangeSearchAction = ({ onOpen }: { onOpen: () => void }) => {
  // const [searchParams, setSearchParams] = useSearchParams();
  // const { setValue } = useFormContext<ExchangeFormValues>();
  // useEffect(() => {
  //   const actionType = searchParams.get('actionType');
  //   if (actionType && actionType === 'exchange') {
  //     const from = mockCurrencyAccountItems.find(
  //       (item) => item.code === searchParams.get('fromCurrency'),
  //     );
  //     const to = mockCurrencyAccountItems.find(
  //       (item) => item.code === searchParams.get('toCurrency'),
  //     );
  //     if (from && to) {
  //       const toAmount = Number(searchParams.get('toAmount') ?? 0);
  //       setValue(
  //         'fee',
  //         toAmount ? parseFloat((toAmount * 0.01).toFixed(2)) : 0,
  //       );
  //       setValue('fromCurrency', from);
  //       setValue('toCurrency', to);
  //       setValue('toAmount', toAmount);
  //       setValue('fromAmount', Number(searchParams.get('fromAmount') ?? 0));
  //       onOpen();
  //     }
  //     setSearchParams();
  //   }
  // }, [searchParams]);
};
